var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudiences({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "audiences",
    transform: "translate(-198 -46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8424",
    "data-name": "Rectangle 8424",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(198 46)",
    fill: "#404246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M15368.327-13007.659h-.3a1.264,1.264,0,0,1-.856-1.574,11.7,11.7,0,0,1-6.434-3.131,11.86,11.86,0,0,1-3.062-6.459h-.612a.981.981,0,0,1-.817-.416,1.866,1.866,0,0,1-.174-.3c-.024-.048-.049-.1-.075-.145v-.295a1.2,1.2,0,0,1,1.278-.884,3.172,3.172,0,0,1,.391.026,11.429,11.429,0,0,1,3.081-6.429,11.968,11.968,0,0,1,6.417-3.069c0-.056,0-.114,0-.176,0-.125,0-.268,0-.409a1.091,1.091,0,0,1,1.013-1.08h.013a1.019,1.019,0,0,1,1,1.061c0,.146,0,.289,0,.426,0,.064,0,.126,0,.186a11.838,11.838,0,0,1,6.464,3.058,11.626,11.626,0,0,1,3.122,6.427h.342l.176,0a1.021,1.021,0,0,1,1.053,1.02,1.024,1.024,0,0,1-1.047,1l-.186,0h-.338a11.79,11.79,0,0,1-3.1,6.493,11.768,11.768,0,0,1-6.484,3.1v.292a1.1,1.1,0,0,1-.864,1.282Zm-2-12.018a.818.818,0,0,0-.322.064,5.066,5.066,0,0,0-2.79,2.937,1.006,1.006,0,0,0,.541,1.438,4.053,4.053,0,0,0,1.358.288c.4.016.837.022,1.379.022.323,0,.651,0,.94,0l.22,0,.721,0,.688,0h.343l1.03,0c.6,0,1.047,0,1.462.013h.017a1.441,1.441,0,0,0,1.138-.7,1.223,1.223,0,0,0,.093-1.22,5.751,5.751,0,0,0-2.663-2.75.75.75,0,0,0-.319-.063.863.863,0,0,0-.259.037,5.725,5.725,0,0,1-1.711.273,4.9,4.9,0,0,1-1.66-.291A.62.62,0,0,0,15366.325-13019.677Zm1.844-6.242a2.764,2.764,0,0,0-1.959.8,2.758,2.758,0,0,0-.8,1.955,2.763,2.763,0,0,0,.788,1.978,2.766,2.766,0,0,0,1.969.809h.013a2.742,2.742,0,0,0,1.961-.8,2.759,2.759,0,0,0,.8-1.971,2.735,2.735,0,0,0-2.76-2.77Z",
    transform: "translate(-15150.566 13085.002)",
    fill: "#f8f8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiences);
export default __webpack_public_path__ + "static/media/audiences.55c234b37f2aab631e69330edc207db9.svg";
export { ForwardRef as ReactComponent };